import {
  type QueryKey,
  type UseQueryOptions,
  useQuery,
} from "@tanstack/react-query";
import { getSearchResults } from "@/features/diets/api/get-diets-results";
import type { DietSearchResultsType } from "@/features/diets/types/diet-search-resilts.type";
import type { MultidietDietsFilterParamsType } from "@/features/multidiet/types/multidiet.type";

type UseWizardResultsParams = {
  filters: Partial<MultidietDietsFilterParamsType>;
  options?: Omit<
    UseQueryOptions<
      DietSearchResultsType,
      unknown,
      DietSearchResultsType,
      string[] | QueryKey
    >,
    "queryFn" | "queryKey"
  >;
};

const useDietsResults = ({ filters, options }: UseWizardResultsParams) => {
  return useQuery({
    queryKey: ["multidiet-diets-results", filters],
    queryFn: () => getSearchResults(filters),
    ...options,
  });
};

export { useDietsResults };
